import { DeviceAddComponent } from './../add/device-add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from './../../../shared/translate/translate.module';

@NgModule({
  declarations: [DeviceAddComponent],
  imports: [
    CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule
  ],
  exports: [
    DeviceAddComponent
  ]
})
export class DeviceAddModule { }
